import { render, staticRenderFns } from "./ResetPasswordConfirm.vue?vue&type=template&id=97d64e90&scoped=true&"
import script from "./ResetPasswordConfirm.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordConfirm.vue?vue&type=script&lang=js&"
import style0 from "./ResetPasswordConfirm.vue?vue&type=style&index=0&id=97d64e90&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97d64e90",
  null
  
)

export default component.exports